module.exports = __webpack_public_path__ + "static/media/J.Y. Liew.58663ae3.png";